import { RegionLead } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramRegionLeads: (
  fetchContext: FetchContext,
  programId: number,
  regionId: number,
  accessToken?: string,
) => Promise<RegionLead[]> = (fetchContext, programId, regionId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/regions/${regionId}/leads`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<RegionLead[]>(fetchContext.errorStore, response, 'get program region leads'));
